export const BASE_URL = import.meta.env.VITE_BASE_URL

export const GET_CONFIG_API =
  'wht-data-management/api/v1/keycloak/mfaConfig/getConfig'
export const GET_TOKEN_API = 'wht-data-management/api/v1/keycloak/token'
export const AUTHENTICATION_API =
  'wht-data-management/api/v1/keycloak/authenticate'
export const TERMS_CONDITIONS_API = 'wht-admin/api/v1/user/term-condition'
export const ACCEPT_TERMS_CONDITIONS_API =
  'wht-admin/api/v1/user/agree/term-condition'
export const UPDATE_PASSWORD_API = 'wht-admin/api/v1/user/update-password'
export const GENERATE_OTP_FOR_MFA_API =
  'wht-data-management/api/v1/keycloak/forgot-password/generate-otp'
export const VERIFY_OTP_FOR_MFA_API =
  'wht-data-management/api/v1/keycloak/forgot-password/verify-otp'
export const SET_MFA_CONFIG_API = 'wht-admin/api/v1/user/mfaConfig/setConfig'
export const REFRESH_TOKEN_API =
  'wht-data-management/api/v1/keycloak/refreshtoken'
export const LOGOUT_API = 'wht-data-management/api/v1/keycloak/logout'
export const GET_USER_ROLE_API = 'wht-data-management/api/v1/keycloak/user/role'

// sso login
export const CLIENT_ID_API = 'wht-data-management/api/v1/sso/get/clientId'
export const GET_CONFIG_SSO =
  'wht-data-management/api/v1/sso/clientConfig/getConfig'
export const SAML_URL = 'wht-data-management/api/saml2/authenticate'
export const GET_EMPLOYEE_LIST = 'wht-data-management/api/v1/sso/employee/list'
export const LOGIN_SSO_API = 'wht-data-management/api/v1/sso/pwc/sso/login'
// Admin User
export const CREATE_USER_API = 'wht-admin/api/v1/user/save'
export const GET_USER_LIST_API = 'wht-admin/api/v1/user/list'
export const DOWNLOAD_USER_LIST_API =
  'wht-admin/api/v1/fileDownload/download/masterData'
export const DELETE_USER_BY_UUID_API = 'wht-admin/api/v1/user/delete'

// Entity
export const SAVE_ENTITY_MASTER_API = 'wht-admin/api/v1/entity-master/save'
export const GET_ENTITY_MASTER_LIST_API = 'wht-admin/api/v1/entity-master/list'
export const DELETE_ENTITY_BY_UUID_API = 'wht-admin/api/v1/entity-master/'
export const UPDATE_ENTITY_MASTER_API = 'wht-admin/api/v1/entity-master/update'
export const DOWNLOAD_ENTITY_MASTER_EXCEL_API =
  'wht-admin/api/v1/fileDownload/download/entityMaster'

// TAN
export const GET_STATE_API = 'wht-admin/api/v1/tan-master/indian-states'
export const GET_MINISTRIES_API = 'wht-admin/api/v1/tan-master/ministries'
export const GET_ENTITY_TYPES_API = 'wht-admin/api/v1/tan-master/entity-types'
export const SAVE_TAN_MASTER_API = 'wht-admin/api/v1/tan-master/save'
export const GET_TAN_MASTER_LIST_API = 'wht-admin/api/v1/tan-master/filter/all'
export const DELETE_TAN_MASTER_API = 'wht-admin/api/v1/tan-master/delete/'
export const DOWNLOAD_TAN_MASTER_EXCEL_API =
  'wht-admin/api/v1/fileDownload/download/tanMasterData'
export const UPDATE_TAN_MASTER_API = 'wht-admin/api/v1/tan-master/update'
export const UPLOAD_CSI_FILE_API = 'wht-admin/api/v1/tan-master/csi/file/upload'
// Assign Entity to User
export const ASSIGN_ENTITY_TO_USER_API = 'wht-admin/api/v1/user/assign-entity'
export const GET_ASSIGNED_USER_LIST_API =
  'wht-admin/api/v1/user/assign-entity/list'
export const DOWNLOAD_USER_ENTITY_EXCEL_API =
  'wht-admin/api/v1/user/assign-entity/download'
export const DELETE_ASSIGNED_ENTITY_API =
  'wht-admin/api/v1/user/assign-entity/delete/' // uuid will be appended
export const DELETE_ASSIGNED_USER_ENTITY_API =
  'wht-admin/api/v1/user/assign-entity/delete/user/' // UserID will be appended
// Section Keyword
export const CREATE_SECTION_KEYWORD_API =
  'wht-data-management/api/v1/section-keyword/create'
export const UPDATE_SECTION_KEYWORD_API =
  'wht-data-management/api/v1/section-keyword'
export const GET_SECTION_KEYWORD_LIST_API =
  'wht-data-management/api/v1/section-keyword/dataList'
export const DOWNLOAD_EXCEL_SECTION_KEYWORD_API =
  'wht-admin/api/v1/fileDownload/download/sectionKeyword'
export const GET_SECTION_DROPDOWN_LIST_API =
  'wht-data-management/api/v1/section-keyword/dropdown'
export const DELETE_SECTION_KEYWORD_API =
  'wht-data-management/api/v1/section-keyword'

// Rule Setting
export const CREATE_RULE_SETTING_API = 'wht-data-management/api/rules/create'
export const DELETE_RULE_API = 'wht-data-management/api/rules'
export const DELETE_CONDITION_API = 'wht-data-management/api/v1/conditions'
export const SEARCH_RULES_API =
  'wht-data-management/api/rules/searchRuleSetting'
export const DOWNLOAD_RULES_API =
  'wht-data-management/api/rules/download/ruleSettingData'
export const GET_TDS_SECTION_DROPDOWN_LIST_API =
  'wht-data-management/api/rules/dropDownTdsSection' // Append TAN UUID
export const GET_RULE_CONDITIONS_API =
  'wht-data-management/api/rules/getCondition' // ruleUUID will be appended
// Section Master
export const CREATE_SECTION_MASTER_API =
  'wht-data-management/api/v1/section-masters'
export const GET_SEARCH_SECTION_MASTER_API =
  'wht-data-management/api/v1/section-masters/filter/by/tan' // tan UUID will be appended
export const GET_APPLICABLE_TO_LIST_API =
  'wht-data-management/api/v1/section-masters/enums/applicable-to'
export const GET_PAYEE_STATUS_LIST_API =
  'wht-data-management/api/v1/section-masters/enums/payee-status'
export const DOWNLOAD_SECTION_MASTER_API =
  'wht-data-management/api/v1/section-masters/download' // tan UUID will be appended
export const BULK_UPDATE_SECTION_API =
  'wht-data-management/api/v1/section-masters/update'
export const UPDATE_RULE_SETTING_API = 'wht-data-management/api/rules/editRules'
// Upload
export const GET_FILE_SOURCE_API =
  'wht-data-management/api/v1/upload/enums/file-source'
export const GET_FILE_DATA_TYPE_API =
  'wht-data-management/api/v1/upload/enums/file-data-type'
export const DOWNLODE_TEMPLET_API =
  'wht-data-management/api/v1/upload/download-template'
export const GET_SECTION_AND_BROAD_API =
  'wht-data-management/api/v1/section-masters/fetch/unique/section-broadheads'
export const GET_TAN_BY_ENTITY_UUID_API =
  'wht-admin/api/v1/tan-master/by/entityUuid'
export const UPLOAD_FILE_API = 'wht-data-management/api/v1/fileUpload/upload'
export const GET_META_DATA_API =
  'wht-data-management/api/v1/upload/get/file-meta-data'
export const DOWNLOAD_META_DATA_API =
  'wht-data-management/api/v1/upload/download/file-meta-data'
export const DELETE_EILE_META_DATA_API =
  'wht-data-management/api/v1/upload/delete/entry-data'
export const DOWNLOAD_SELECTED_FILE_API =
  'wht-data-management/api/v1/upload/download/original-file'
export const DOWNLOAD_SELECTED_ERROR_FILE_API =
  'wht-data-management/api/v1/upload/download/error-file'

// Vendor Master
export const SEARCH_FILTER_VENDOR =
  'wht-data-management/api/v1/vendor/searchFilterVendor'
export const DOWNLOAD_VENDOR_DTEAILS_DATA =
  'wht-data-management/api/v1/vendor/download/masterData'
export const SEARCH_FILTER_VENDOR_LDC =
  'wht-data-management/api/v1/vendor/searchFilterVendorLDC'
export const DOWNLOAD_VENDOR_LDC_DATA =
  'wht-data-management/api/v1/vendor/download/masterDataLDC'
export const DELETE_VENDOR_MASTER =
  'wht-data-management/api/v1/vendor/delete/vendorMaster'
export const EDIT_VENDOR_DETAILS =
  'wht-data-management/api/v1/vendor/editVendor'
export const EDIT_VENDOR_LDC_DETAILS =
  'wht-data-management/api/v1/vendor/editVendorLDC'
export const DELETE_VENDOR_LDC_API =
  'wht-data-management/api/v1/vendor/delete/vendorMasterLDC'
// prepare page
export const GET_TRANSACTIONAL_DATA_API =
  'wht-data-management/api/v1/data-validation/transactional-data'
export const REPROCESS_VALIDATION_API =
  'wht-data-management/api/v1/data-validation/transactional-data/reprocess'
export const INCLUDE_EXCLUDE_DATA_API = 'wht-data-management/api/v1/fileUpload'
export const DOWNLOAD_PREPARE_DATA_API =
  'wht-data-management/api/v1/data-validation/transactional-data/excel'
export const FILE_UPLOAD_SUMMARY_API =
  'wht-data-management/api/v1/fileUpload/summary'
export const CALCULATE_TDS_RATE_DATA =
  'wht-data-management/api/v1/fileUpload/calculateRate'
export const GET_NEGATIVE_ENTERIES_DATA =
  'wht-data-management/api/v1/set-off/fetch-data'
export const TRANSACTIONAL_DATA_SUM_API =
  'wht-data-management/api/v1/data-validation/transactional-data/total-sum'
//Advances & Provisions
export const FETCH_PROVISION_DATA =
  'wht-data-management/api/v1/knock-off/fetch-data'
export const FETCH_ADVANCE_DATA = 'fetchAdvanceData'
export const DOWNLOAD_PROVISION_EXCEL =
  'wht-data-management/api/v1/knock-off/data/excel'

// downloads Page
export const GET_DOWNLOADS_DATA =
  'wht-data-management/api/v1/file-download/data'
export const DOWNLOAD_FILE_BY_ID_API =
  'wht-data-management/api/v1/file-download/files'

// compute page
export const GET_COMPUTE_DATA_API =
  'wht-data-management/api/v1/data-validation/transactional-data/compute/PROCESSED'
export const DOWNLOAD_COMPUTE_EXCEL_API =
  'wht-data-management/api/v1/data-validation/transactional-data/compute/excel/PROCESSED'
export const TOTAL_SUM_COMPUTE_DATA =
  'wht-data-management/api/v1/data-validation/transactional-data/total-sum/PROCESSED'

// User Consent
export const DOWNLOAD_USER_CONSENT_API =
  'wht-data-management/api/v1/file-download/download-consent-summary'

// premium feature gen AI and ldc challan
export const GET_CLIENT_NAME =
  'wht-data-management/api/v1/premium-feature/client'
export const PREMIUM_FEATURE_DOWNLOAD_EXCEL_API =
  'wht-data-management/api/v1/premium-feature/download'
export const ADD_UPDATE_PREMIUM_FEATURE_API =
  'wht-data-management/api/v1/premium-feature/save'
export const GET_PREMIUM_FEATURE_DATA =
  'wht-data-management/api/v1/premium-feature'
export const GET_GEN_AI_STATUS_API =
  'wht-data-management/api/v1/premium-feature/gen-ai/status'

// duplication Rule
export const GET_DUPLICATION_RULE_LIST_API =
  'wht-admin/api/v1/duplication-rules/tanUuid'
export const ADD_DUPLIACATE_RULE_API = 'wht-admin/api/v1/duplication-rules'
export const UPDATE_DUPLIACATE_RULE_API = 'wht-admin/api/v1/duplication-rules'
export const DOWNLOAD_EXCEL_DUPLICATION_RULE_API =
  'wht-admin/api/v1/duplication-rules/download/tanUuid'

// allocation status
export const SEARCH_VENDOR_CHALLAN =
  'wht-data-management/api/v1/challan/searchFilterVendorChallan'
export const GET_ALLOCATION_STATUS =
  'wht-data-management/api/v1/challan/enums/allocation-status'
export const GET_ALLOCATION_CHALLAN =
  'wht-data-management/api/v1/challan/enums/allocation-challan'
export const EDIT_VENDOR_CHALLAN =
  'wht-data-management/api/v1/challan/editVendorChallan'
export const DOWNLOAD_CHALLAN_DATA =
  'wht-data-management/api/v1/challan/download/challan'
export const RELEASE_ALLOCATION_CHALLAN =
  'wht-data-management/api/v1/challan/release/allocated-challan'
export const AUTOMATE_ALLOCATE =
  'wht-data-management/api/v1/challan/automated/allocation'
export const ALLOCATE_PRIOR_CHALLAN =
  'wht-data-management/api/v1/challan/prior/challan'
export const DELETE_CHALLAN = 'wht-data-management/api/v1/challan/delete'

// Returns page

export const RETURNS_FORM = 'wht-admin/api/v1/returns/form' //retrive data
export const RETURNS_DOWNLOAD_EXCEL =
  'wht-admin/api/v1/returns/return-data/excel'
export const RETURNS_FORM_EDIT = 'wht-admin/api/v1/returns/form/edit'
export const RETURNS_LIST = 'wht-admin/api/v1/returns/list'
export const RETURNS_CHALLAN_LIST = 'wht-admin/api/v1/returns/challan'
export const RETURNS_EDIT_CHALLAN = 'wht-admin/api/v1/returns/edit/challan'
export const RETURNS_ANNEXURE_LIST = 'wht-admin/api/v1/returns/annexure'
export const RETURNS_EDIT_ANNEXURE = 'wht-admin/api/v1/returns/edit/annexure'
export const RETURNS_TYPES = 'wht-admin/api/v1/returns/enums-return-types'
export const RETURNS_QUARTERS = 'wht-admin/api/v1/returns/enums-quarters'
export const RETURNS_GENERATE_FILE = 'wht-admin/api/v1/returns/generate-file'
export const RETURNS_DOWNLOAD_FILES = 'wht-admin/api/v1/returns/download-file'
export const RETURNS_DOWNLOAD_LIST =
  'wht-admin/api/v1/returns/list/download-file'
export const RETURNS_REFRESH = 'wht-admin/api/v1/returns/refresh'
export const RETURNS_FVU_GENERATE = 'wht-admin/api/v1/returns/generate/fvu'

// Self Service (DWH iframe embed)
// NOTE: Confirm these BE endpoints with the backend team.
// generateToken -> returns { access_token, refresh_token, dwhBaseUrl }
export const SELF_SERVICE_GENERATE_TOKEN_API =
  'wht-data-management/api/v1/dwhauth/token'
// generateRefreshTokenDWH -> returns { access_token }
export const SELF_SERVICE_REFRESH_TOKEN_API =
  'wht-data-management/api/v1/dwhauth/refreshtoken'
export const NEW_SECTION_CODE = 'wht-admin/api/v1/returns/section-codes/new'

// Compliance Master
export const COMPLIANCE_MASTER_LIST_API = 'wht-admin/api/v1/compliance-master/list'
export const COMPLIANCE_MASTER_CREATE_API = 'wht-admin/api/v1/compliance-master/create'
export const COMPLIANCE_MASTER_CATEGORIES_API = 'wht-admin/api/v1/compliance-master/categories'
export const COMPLIANCE_MASTER_DELETE_API = 'wht-admin/api/v1/compliance-master/delete'
export const COMPLIANCE_MASTER_DOWNLOAD_API = 'wht-admin/api/v1/compliance-master/download'
// completion-date PATCH endpoint: `${BASE}/wht-admin/api/v1/compliance-master/{uuid}/completion-date`
export const COMPLIANCE_MASTER_BASE_API = 'wht-admin/api/v1/compliance-master'
